import React from "react";
var __jsx = React.createElement;
import Spacer from './Spacer';
function SpacerAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(Spacer, entry);
}
export default SpacerAdapter;